<div class="static-content-list">
    <app-static-content *ngFor="let content of contents$ | async"
        [requestDataFromBackend]="false" 
        [contentId]="content.contentId">
    </app-static-content>
</div>